// extracted by mini-css-extract-plugin
export default {"publish-section-base-text-modal":"PublishSectionBaseTextModal_publish-section-base-text-modal__ypL4F","title":"PublishSectionBaseTextModal_title__LTEH0"};